/* "Read more" in de kaarten van mv-testimonials: wisselt korte en volledige tekst.
   Eén luisteraar op document, zodat het ook werkt na een herlaad van de sectie in de theme editor. */
if (!window.mvTestimonialsKlaar) {
  window.mvTestimonialsKlaar = true;
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('.mv-tm__meer');
    if (!knop) return;
    const tekst = knop.closest('[data-mv-tm-tekst]');
    if (!tekst) return;
    const open = knop.getAttribute('aria-expanded') !== 'true';
    knop.setAttribute('aria-expanded', String(open));
    knop.textContent = open ? knop.dataset.minder : knop.dataset.meer;
    tekst.querySelector('.mv-tm__tekst-kort').hidden = open;
    tekst.querySelector('.mv-tm__tekst-lang').hidden = !open;
  });
}
